import { Component, EventEmitter, Input, Output } from '@angular/core';

import { Widget } from '../../../models/core.models';

@Component({
  selector: 'app-widget-preview-popup',
  templateUrl: './widget-preview-popup.component.html',
  styleUrl: './widget-preview-popup.component.scss',
  standalone: false,
})
export class WidgetPreviewPopupComponent {
  @Input() widget: Widget | null = null;
  @Input() isLoading = false;
  @Input() rtl = false;
  @Input() width = 800;
  @Input() height = 400;

  @Output() close = new EventEmitter<void>();
  @Output() dock = new EventEmitter<void>();

  onCloseClick() {
    this.close.emit();
  }

  onDock() {
    this.dock.emit();
  }
}
